export default __webpack_public_path__ + "static/media/(2).81b6d6be.jpeg";